module.exports = __webpack_public_path__ + "static/img/model-bg35.237e531.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg35.jpg
// module id = CxKV
// module chunks = 0